export default __webpack_public_path__ + "static/media/spinner-fede.fdbcbf57.gif";